import React, { useEffect, useRef, useState } from 'react';
import { Room, RoomEvent, Track } from 'livekit-client';
import { LiveKitRoom } from '@livekit/components-react';
import ChatRoom from '../chats/ChatRoom';
import ButtonBase from '../buttons/ButtonBase';
import VideoConference from './CustomVideoConference';
import { $host } from '../../../../http';

const VideoStreaming = ({ token, url, updateToken, roomId }) => {
  const roomRef = useRef(null);
  const [room, setRoom] = useState(null);

  useEffect(() => {
    const connectToRoom = async () => {
      const newRoom = new Room();

      newRoom.on(RoomEvent.TrackSubscribed, (track, publication, participant) => {
        if (track.kind === Track.Kind.Video) {
          // Handle video track
        } else if (track.kind === Track.Kind.Audio) {
          // Handle audio track
        }
      });

      newRoom.on(RoomEvent.DataReceived, (data, participant) => {

      });
      try {
        await newRoom.connect(url, token);
        setRoom(newRoom);
        roomRef.current = newRoom;
      } catch (e) {
        if (e.status && e.status === 401) {
          console.debug('given token is expired. recreating...')
          localStorage.removeItem('chat_token')
          await updateToken()
        }
      }

    };

    connectToRoom();

    return () => {
      if (roomRef.current) {
        roomRef.current.disconnect();
      }
    };
  }, [token, url]);

  const [isRecording, setIsRecording] = useState(false);

  const startRecording = async () => {
    try {
      const response = await $host.post(`/api/teachers/webinar/start-record/${roomId}`);
      setIsRecording(true);
      console.log('Recording started:', response.data);
    } catch (error) {
      console.error('Error starting recording:', error);
    }
  };

  const stopRecording = async () => {
    try {
      const response = await $host.post(`/api/teachers/webinar/stop-record/${roomId}`);
      setIsRecording(false);
      console.log('Recording stopped:', response.data);
    } catch (error) {
      console.error('Error stopping recording:', error);
    }
  };

  return (
    <div className="video-streaming-container">
      {room ? (
        <>
          <LiveKitRoom room={room} className='w-full'>
          <div className='flex w-full items-center justify-between'>
            {isRecording ? (
              <ButtonBase onClick={stopRecording}>Остановить запись</ButtonBase>
            ) : (
              <ButtonBase onClick={startRecording}>Начать запись</ButtonBase>
            )}
          </div>
            <VideoConference />
            <ChatRoom room={room} />
          </LiveKitRoom>
        </>
      ) : (
        <p>Connecting to the room...</p>
      )}
    </div>
  );
};

export default VideoStreaming;
